// removed by extract-text-webpack-plugin
module.exports = {"button":"button-module__button___38F6g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/button/button.module.scss
// module id = 903
// module chunks = 0 1